import React, { useEffect, useState } from 'react';

const Settings: React.FC = () => {
  const [darkMode, setDarkMode] = useState(() => localStorage.getItem('darkMode') === 'true');

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add('dark');
      localStorage.setItem('darkMode', 'true');
    } else {
      document.body.classList.remove('dark');
      localStorage.setItem('darkMode', 'false');
    }
  }, [darkMode]);

  return (
    <div className="flex flex-col items-center justify-center h-[60vh] bg-transparent">
      <div className="bg-white dark:bg-gray-900 shadow-2xl rounded-2xl p-10 w-full max-w-md flex flex-col items-center">
        <h1 className="text-2xl font-bold text-blue-700 dark:text-blue-300 mb-4">Тохиргоо</h1>
        <p className="text-gray-600 dark:text-gray-300 text-lg mb-8">Таны тохиргооны хуудсанд тавтай морил!</p>
        <div className="flex items-center gap-4 mb-2">
          <span className="text-gray-700 dark:text-gray-200 font-medium">🌙 Dark Mode</span>
          <button
            className={`relative w-14 h-8 rounded-full transition-colors duration-300 focus:outline-none ${darkMode ? 'bg-blue-600' : 'bg-gray-300'}`}
            onClick={() => setDarkMode((v) => !v)}
            aria-label="Toggle dark mode"
          >
            <span
              className={`absolute left-1 top-1 w-6 h-6 rounded-full bg-white shadow-md transition-transform duration-300 ${darkMode ? 'translate-x-6' : ''}`}
            />
          </button>
        </div>
        <span className="text-xs text-gray-400 dark:text-gray-500">Таны сонголт хадгалагдана</span>
      </div>
      {/* Add dark mode styles */}
      <style>{`
        body.dark {
          background: #181e29 !important;
        }
        .dark .bg-white { background-color: #232b3a !important; }
        .dark .text-blue-700 { color: #60a5fa !important; }
        .dark .text-gray-600 { color: #cbd5e1 !important; }
        .dark .shadow-2xl { box-shadow: 0 8px 32px 0 rgba(0,0,0,0.45) !important; }
      `}</style>
    </div>
  );
};

export default Settings;
